// extracted by mini-css-extract-plugin
export default {"tab":"index_tab_11COx clearfix","tabItem":"index_tabItem_v9rZ-","active":"index_active_B-9-N","select":"index_select_UINRo clearfix"};